import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function ShiftsDealIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [_jsx("path", { d: "M5.889 12.712a.25.25 0 01-.073-.176l-.75.004.75-.004-.03-5.88a.25.25 0 01.251-.252l5.9.013a.25.25 0 01.176.073l6.793 6.793a.25.25 0 010 .353l-5.87 5.87a.25.25 0 01-.353 0l-6.794-6.794z", stroke: primaryFillColor, strokeWidth: 1.5 }), _jsx("circle", { cx: 8.4, cy: 9, r: 1, fill: primaryFillColor })] }));
}
//# sourceMappingURL=Deal.js.map